<template>
  <div>
    <div class="btn btn-xs btn-outline" @click="showOcSelector = true">
      <div class="max-w-20 flex items-center gap-1">
        <span class="flex-1 line-clamp-1 whitespace-nowrap">
          {{
            activeMateId
              ? mateStore.getMyMateById(activeMateId)?.name
              : "全部 OC"
          }}
        </span>
        <i class="iconify mingcute--triangle-fill rotate-180 w-2.5"></i>
      </div>
    </div>

    <ModalSelectAllMate
      :active-mate-id="activeMateId"
      v-model:show="showOcSelector"
      @confirm="onConfirmOc"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useMate } from "@/stores/mate";
defineProps<{
  activeMateId: number | undefined;
}>();

const emit = defineEmits<{
  (event: "confirm", value?: number): void;
}>();

const showOcSelector = ref(false);

const mateStore = useMate();

const onConfirmOc = (value?: number) => {
  emit("confirm", value);
  showOcSelector.value = false;
};
</script>
